import { Component, OnInit } from "@angular/core";
import { SendSuggestionInputDTO } from "src/app/models/social.models/suggestion.models/sendSuggestionInputDTO.model";
import {
  FormBuilder,
  FormControl,
  Validators,
  FormGroup
} from "@angular/forms";
import { SuggestionsSiteService } from "src/app/services/suggestionsSite.service";

@Component({
  selector: "contactusform",
  templateUrl: "./contactusform.component.html"
})
export class ContactUsFormComponent implements OnInit {
  ngOnInit(): void {}

  sendSuggestionInputDTO: SendSuggestionInputDTO = new SendSuggestionInputDTO();

  showLoadingGif: boolean = false;
  showReponseMessage: boolean = false;
  responseMessage: string = "";

  constructor(
    private formBuilder: FormBuilder,
    private suggestionsSiteService: SuggestionsSiteService
  ) {}

  email: FormControl = new FormControl("", [
    Validators.required,
    Validators.pattern("^[a-zA-Z0-9_\\.-]+@([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$"),
    Validators.maxLength(256)
  ]);

  fullName: FormControl = new FormControl("", [
    Validators.required,
    Validators.minLength(4),
    Validators.maxLength(256)
  ]);

  subject: FormControl = new FormControl("", [
    Validators.required,
    Validators.minLength(2),
    Validators.maxLength(512)
  ]);

  description: FormControl = new FormControl("", [
    Validators.required,
    Validators.minLength(2),
    Validators.maxLength(2048)
  ]);

  recaptcha: FormControl = new FormControl("", [Validators.required]);

  suggestionForm: FormGroup = this.formBuilder.group({
    email: this.email,
    fullName: this.fullName,
    subject: this.subject,
    description: this.description,
    recaptcha: this.recaptcha
  });

  SendSuggestion() {
    this.showLoadingGif = true;
    this.showReponseMessage = false;
    this.responseMessage = "";

    this.suggestionsSiteService
      .SendSuggestion(this.suggestionForm.value)
      .subscribe(
        p => {
          this.suggestionForm.reset();

          this.showLoadingGif = false;
          this.showReponseMessage = true;
          this.responseMessage =
            "پیام شما با موفقیت ارسال شد. با تشکر از تماس شما";
        },
        p => {
          this.showLoadingGif = false;
          this.showReponseMessage = true;
          this.responseMessage =
            "متاسفانه خطایی پیش آمده است. لطفا مجددا سعی نمایید";
        }
      );
  }
}
